// RecycleBin.tsx
import React from 'react';
import recycleBinImage from '../assets/icons/recycle_bin.png';
import '../index.css';
import './CommonDialog.css';

interface RecycleBinProps {
  onClose: () => void;
}

const RecycleBin: React.FC<RecycleBinProps> = ({ onClose }) => {
  return (
    <div className="common-dialog-container">
      <div className="common-dialog-content">
        <div className="common-dialog-image-container">
          <img src={recycleBinImage} alt="Recycle Bin" className="common-dialog-image" />
        </div>
        <div className="common-dialog-right-content">
          <span className="common-dialog-message message-text">ここにはいない</span>
          <button 
            className="btn-common btn-large"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecycleBin;
